import { render, staticRenderFns } from "./LawSubjectForm.vue?vue&type=template&id=a9bfc1f8&"
import script from "./LawSubjectForm.vue?vue&type=script&lang=js&"
export * from "./LawSubjectForm.vue?vue&type=script&lang=js&"
import style0 from "./LawSubjectForm.vue?vue&type=style&index=0&id=a9bfc1f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports